import { cva } from 'class-variance-authority'

export const tableHeaderStyles = cva('', {
  variants: {
    sticky: {
      true: 'sticky top-0 z-10',
    },
  },
})

export const tableFooterStyles = cva(
  `
    bg-neutral-100
    [&>tr]:border-none
    `,
  {
    variants: {
      compact: {
        very: 'text-xs',
      },
    },
  }
)

export const tableRowStyles = cva('border-b border-neutral-200', {
  variants: {
    compact: {
      very: 'text-xs',
    },
  },
})

export const tableHeaderCellStyles = cva('p-2', {
  variants: {
    sortable: {
      true: 'cursor-pointer',
      false: 'cursor-default',
    },
    compact: {
      very: 'py-1 px-1 text-xs',
    },
  },
  defaultVariants: {
    sortable: true,
  },
})
export const tableHeaderCellIconStyles = cva(
  `
    h-[10px]
    ml-[8px]
    `,
  {
    variants: {
      hasTwoIcons: {
        true: '-mt-[4px]',
        false: '',
      },
    },
    defaultVariants: {
      hasTwoIcons: false,
    },
  }
)

export const tableHeaderCellDualIconWrapperStyles = cva(
  `
    pt-[4px]
    ml-[2px]
    flex
    flex-col
    `
)

export const tableHeaderCellWrapperStyles = cva(
  `
    flex
    items-center
    `
)

export const tableCellStyles = cva('p-2 overflow-hidden', {
  variants: {
    compact: {
      very: 'py-1 px-2 text-xs',
    },
  },
})
